import React from 'react';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPCard } from 'UI/components/atoms/FPCard';

import { useStyles } from './styles';

export const KeywordTags = ({ keywordTags = [], loading }) => {
  const classes = useStyles();

  const hasKeywordTags = Array.isArray(keywordTags) && keywordTags?.length > 0;
  const showKeywordTags = !loading && hasKeywordTags;

  return showKeywordTags ? (
    <div className={classes.container}>
      <FPCard>
        <div className={classes.content}>
          <Typography variant="overline">
            {strings.inventoryProfiles.common.keywords.title}:
          </Typography>

          {keywordTags.map(({ id, display_text: displayText }) => (
            <Chip key={id} label={displayText} size="small" />
          ))}
        </div>
      </FPCard>
    </div>
  ) : null;
};
